/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SubscriptionPaymentAdminRowData
 */
export interface SubscriptionPaymentAdminRowData {
    /**
     * 
     * @type {string}
     * @memberof SubscriptionPaymentAdminRowData
     */
    subscriptionId?: string;
    /**
     * 
     * @type {string}
     * @memberof SubscriptionPaymentAdminRowData
     */
    stripeChargeId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SubscriptionPaymentAdminRowData
     */
    stripePaymentIntentId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SubscriptionPaymentAdminRowData
     */
    stripeInvoiceId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SubscriptionPaymentAdminRowData
     */
    projectId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SubscriptionPaymentAdminRowData
     */
    projectName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SubscriptionPaymentAdminRowData
     */
    packageCode?: string | null;
    /**
     * 
     * @type {number}
     * @memberof SubscriptionPaymentAdminRowData
     */
    amount?: number;
    /**
     * 
     * @type {string}
     * @memberof SubscriptionPaymentAdminRowData
     */
    currency?: string;
    /**
     * 
     * @type {string}
     * @memberof SubscriptionPaymentAdminRowData
     */
    paymentStatus?: string;
    /**
     * 
     * @type {string}
     * @memberof SubscriptionPaymentAdminRowData
     */
    invoiceStatus?: string;
    /**
     * 
     * @type {Date}
     * @memberof SubscriptionPaymentAdminRowData
     */
    expectedAt?: Date;
    /**
     * 
     * @type {Date}
     * @memberof SubscriptionPaymentAdminRowData
     */
    paidAt?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof SubscriptionPaymentAdminRowData
     */
    failureReason?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof SubscriptionPaymentAdminRowData
     */
    invoiceMatchIsExact?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SubscriptionPaymentAdminRowData
     */
    packageMatchIsExact?: boolean;
}

/**
 * Check if a given object implements the SubscriptionPaymentAdminRowData interface.
 */
export function instanceOfSubscriptionPaymentAdminRowData(value: object): value is SubscriptionPaymentAdminRowData {
    return true;
}

export function SubscriptionPaymentAdminRowDataFromJSON(json: any): SubscriptionPaymentAdminRowData {
    return SubscriptionPaymentAdminRowDataFromJSONTyped(json, false);
}

export function SubscriptionPaymentAdminRowDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): SubscriptionPaymentAdminRowData {
    if (json == null) {
        return json;
    }
    return {
        
        'subscriptionId': json['subscriptionId'] == null ? undefined : json['subscriptionId'],
        'stripeChargeId': json['stripeChargeId'] === undefined ? undefined : json['stripeChargeId'] === null ? null : json['stripeChargeId'],
        'stripePaymentIntentId': json['stripePaymentIntentId'] === undefined ? undefined : json['stripePaymentIntentId'] === null ? null : json['stripePaymentIntentId'],
        'stripeInvoiceId': json['stripeInvoiceId'] === undefined ? undefined : json['stripeInvoiceId'] === null ? null : json['stripeInvoiceId'],
        'projectId': json['projectId'] === undefined ? undefined : json['projectId'] === null ? null : json['projectId'],
        'projectName': json['projectName'] === undefined ? undefined : json['projectName'] === null ? null : json['projectName'],
        'packageCode': json['packageCode'] === undefined ? undefined : json['packageCode'] === null ? null : json['packageCode'],
        'amount': json['amount'] == null ? undefined : json['amount'],
        'currency': json['currency'] == null ? undefined : json['currency'],
        'paymentStatus': json['paymentStatus'] == null ? undefined : json['paymentStatus'],
        'invoiceStatus': json['invoiceStatus'] == null ? undefined : json['invoiceStatus'],
        'expectedAt': json['expectedAt'] == null ? undefined : (new Date(json['expectedAt'])),
        'paidAt': json['paidAt'] === undefined ? undefined : json['paidAt'] === null ? null : (new Date(json['paidAt'])),
        'failureReason': json['failureReason'] === undefined ? undefined : json['failureReason'] === null ? null : json['failureReason'],
        'invoiceMatchIsExact': json['invoiceMatchIsExact'] == null ? undefined : json['invoiceMatchIsExact'],
        'packageMatchIsExact': json['packageMatchIsExact'] == null ? undefined : json['packageMatchIsExact'],
    };
}

export function SubscriptionPaymentAdminRowDataToJSON(json: any): SubscriptionPaymentAdminRowData {
    return SubscriptionPaymentAdminRowDataToJSONTyped(json, false);
}

export function SubscriptionPaymentAdminRowDataToJSONTyped(value?: SubscriptionPaymentAdminRowData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'subscriptionId': value['subscriptionId'],
        'stripeChargeId': value['stripeChargeId'],
        'stripePaymentIntentId': value['stripePaymentIntentId'],
        'stripeInvoiceId': value['stripeInvoiceId'],
        'projectId': value['projectId'],
        'projectName': value['projectName'],
        'packageCode': value['packageCode'],
        'amount': value['amount'],
        'currency': value['currency'],
        'paymentStatus': value['paymentStatus'],
        'invoiceStatus': value['invoiceStatus'],
        'expectedAt': value['expectedAt'] == null ? value['expectedAt'] : value['expectedAt'].toISOString(),
        'paidAt': value['paidAt'] == null ? value['paidAt'] : value['paidAt'].toISOString(),
        'failureReason': value['failureReason'],
        'invoiceMatchIsExact': value['invoiceMatchIsExact'],
        'packageMatchIsExact': value['packageMatchIsExact'],
    };
}

